import { c as _c } from "react/compiler-runtime";
import type { Distribution } from "@/entities/IDistribution";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import CommonTablePagination from "@/components/utils/table/paginator/CommonTablePagination";
import CommonCardSkeleton from "@/components/utils/animation/CommonCardSkeleton";
import UserPageStatsActivityDistributionsTable from "./UserPageStatsActivityDistributionsTable";
export default function UserPageStatsActivityDistributionsTableWrapper(t0) {
  const $ = _c(8);
  const {
    data,
    profile,
    isFirstLoading,
    loading,
    page,
    totalPages,
    setPage
  } = t0;
  if (isFirstLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-mt-2 sm:tw-mt-4 tw-w-full tw-h-96"><CommonCardSkeleton /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== data || $[2] !== loading || $[3] !== page || $[4] !== profile || $[5] !== setPage || $[6] !== totalPages) {
    t1 = <div className="tw-mt-2 lg:tw-mt-4 tw-bg-iron-950 tw-border tw-border-iron-700 tw-border-solid tw-rounded-lg tw-overflow-x-auto">{data.length ? <div className="tw-flow-root"><UserPageStatsActivityDistributionsTable items={data} profile={profile} loading={loading} />{totalPages > 1 && <CommonTablePagination currentPage={page} setCurrentPage={setPage} totalPages={totalPages} haveNextPage={page < totalPages} small={true} loading={loading} />}</div> : <div className="tw-p-4 sm:tw-px-6 tw-text-sm tw-italic tw-text-iron-500">No distributions found</div>}</div>;
    $[1] = data;
    $[2] = loading;
    $[3] = page;
    $[4] = profile;
    $[5] = setPage;
    $[6] = totalPages;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}